const ValidatePhone = (phone) => {
    const regex = /^\d{10}$/;
    return regex.test(phone);
}

export default ValidatePhone